const PRICINGOVERVIEW = {
  TOTAL_PAYABLE: "Total Payable Amount",
  CURRENCY: "Rs.",
  DISCOUNT_CURRENCY: "- Rs.",
  OVERVIEW: "Overview",
  TEXT: {
    subtotal: "Subtotal",
    discounts: "Discount",
    tax: "GST",
    shippingCost: "Delivery Charges",
    loyalty: "Loyalty",
    netAmount: "Net Amount",
    CODCharges: "COD Charges",
  },
  TOTAL: {
    total: "Total",
  },
};

export default PRICINGOVERVIEW;
